export const operationName = 'KnowledgeDiscoveryZeroQueries';

export const quickFindZeroQueriesQuery: '\n  query KnowledgeDiscoveryZeroQueries($cloudId: String!, $product: KnowledgeDiscoveryProduct) {\n\t\tknowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries") {\n\t\t\tzeroQueries(cloudId: $cloudId, product: $product) {\n                __typename\n                ... on KnowledgeDiscoveryZeroQueries {\n                    zeroQueries {\n                        query\n                        type\n\t\t\t\t\t\tproduct\n\t\t\t\t\t\taccountId\n\t\t\t\t\t\tavatarUrl\n\t\t\t\t\t\tdateRange\n\t\t\t\t\t}\n                }\n            }\n\t\t}\n\t}\n' = `
  query ${operationName}($cloudId: String!, $product: KnowledgeDiscoveryProduct) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries") {
			zeroQueries(cloudId: $cloudId, product: $product) {
                __typename
                ... on KnowledgeDiscoveryZeroQueries {
                    zeroQueries {
                        query
                        type
						product
						accountId
						avatarUrl
						dateRange
					}
                }
            }
		}
	}
`;

export const mutateOperationName = 'MarkZeroQueryInteracted';

export const quickFindMutateZeroQueriesMutation: '\n\tmutation MarkZeroQueryInteracted($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {\n\t\tknowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted") {\n\t\t\tmarkZeroQueryInteracted(input: $input) {\n\t\t\t\tsuccess\n\t\t\t\terrors {\n\t\t\t\t\tmessage\n\t\t\t\t\textensions {\n\t\t\t\t\t\terrorType\n\t\t\t\t\t\tstatusCode\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n' = `
	mutation ${mutateOperationName}($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted") {
			markZeroQueryInteracted(input: $input) {
				success
				errors {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;

export const operationNameV1 = 'KnowledgeDiscoveryZeroQueriesV1';

export const quickFindZeroQueriesQueryV1: '\n  query KnowledgeDiscoveryZeroQueriesV1($cloudId: String!, $product: KnowledgeDiscoveryProduct) {\n\t\tknowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries V1") {\n\t\t\tzeroQueriesV1(cloudId: $cloudId, product: $product) {\n                __typename\n                ... on KnowledgeDiscoveryZeroQueries {\n                    zeroQueries {\n                        query\n                        type\n\t\t\t\t\t\tproduct\n\t\t\t\t\t\taccountId\n\t\t\t\t\t\tavatarUrl\n\t\t\t\t\t\tdateRange\n\t\t\t\t\t}\n                }\n            }\n\t\t}\n\t}\n' = `
  query ${operationNameV1}($cloudId: String!, $product: KnowledgeDiscoveryProduct) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries V1") {
			zeroQueriesV1(cloudId: $cloudId, product: $product) {
                __typename
                ... on KnowledgeDiscoveryZeroQueries {
                    zeroQueries {
                        query
                        type
						product
						accountId
						avatarUrl
						dateRange
					}
                }
            }
		}
	}
`;

export const mutateOperationNameV1 = 'MarkZeroQueryInteractedV1';

export const quickFindMutateZeroQueriesMutationV1: '\n\tmutation MarkZeroQueryInteractedV1($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {\n\t\tknowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted V1") {\n\t\t\tmarkZeroQueryInteractedV1(input: $input) {\n\t\t\t\tsuccess\n\t\t\t\terrors {\n\t\t\t\t\tmessage\n\t\t\t\t\textensions {\n\t\t\t\t\t\terrorType\n\t\t\t\t\t\tstatusCode\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n' = `
	mutation ${mutateOperationNameV1}($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted V1") {
			markZeroQueryInteractedV1(input: $input) {
				success
				errors {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;
